const getPatientFirstName = ({ patient, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }

  return patient['First Name'].toUpperCase();
};

export default getPatientFirstName;



// WEBPACK FOOTER //
// ./src/utils/print/getPatientFirstName.js